import React from 'react';
import { useTranslation } from 'react-i18next';
import { OrganizationVerify } from '@Components';

const OrganizationVerifyController = () => {
  const { t } = useTranslation('account');

  const informationCardsDetails = [
    {
      title: t('verify.information_card.stand_out.title'),
      description: t('verify.information_card.stand_out.description'),
      icon: '/assets/OrganizationVerify/StandOutIcon.svg',
      iconAlt: 'verified profile badge',
    },
    {
      title: t('verify.information_card.save_time.title'),
      description: t('verify.information_card.save_time.description'),
      icon: '/assets/OrganizationVerify/SaveTimeIcon.svg',
      iconAlt: 'clock icon',
    },
    {
      title: t('verify.information_card.invest_once.title'),
      description: t('verify.information_card.invest_once.description'),
      icon: '/assets/OrganizationVerify/InvestOnceIcon.svg',
      iconAlt: 'cycling arrows icon',
    },
  ];

  return <OrganizationVerify informationCardsDetails={informationCardsDetails} />;
};

export default OrganizationVerifyController;
